import { defineField } from 'sanity'
import { strongEmLink } from '../../data/richText'
import { seoFields } from './seoFields'

export const gallerySeoGroup = {
  name: 'gallerySEO',
  title: 'Gallery SEO data',
}

export default () => ({
  title: 'Gallery Page Info',
  name: 'galleryPageInfo',
  type: 'object',
  group: 'gallerySEO',
  fields: [
    defineField({
      title: 'Intro Text',
      name: 'introText',
      type: 'array',
      of: strongEmLink,
      description: 'Introductory text displayed on the gallery page',
    }),
    ...seoFields,
  ],
})
